import { parseDigits } from '@/utils';

export const formatDocument = (value: string) => {
  const numericValue = parseDigits(value);
  const numericValueLength = numericValue.length;

  if (numericValueLength > 9) {
    return `${numericValue.slice(0, 3)}.${numericValue.slice(3, 6)}.${numericValue.slice(6, 9)}-${numericValue.slice(9, 11)}`;
  }

  if (numericValueLength > 6) {
    return `${numericValue.slice(0, 3)}.${numericValue.slice(3, 6)}.${numericValue.slice(6, 9)}`;
  }

  if (numericValueLength > 3) {
    return `${numericValue.slice(0, 3)}.${numericValue.slice(3, 6)}`;
  }

  return numericValue;
};
